<section class="py-5">
    <div class="container-fluid mt-3">
        <div class="row justify-content-center">
            <div class="col-10 text-start">
                <section class="terms-and-conditions">
                   

                    <h1>Terms and Conditions</h1>
                    <p><strong>Effective Date:</strong> 01/04/2025</p>
                    <p>By accessing or using this Website, you agree to comply with and be bound by the following terms and conditions ("Terms"). If you do not agree with these Terms, please do not use the Website.</p>
                    
                    <h2>1. Acceptance of Terms</h2>
                    <p>By using the Website, you agree to these Terms, as well as our Privacy Policy. We reserve the right to update or modify these Terms at any time without prior notice. Your continued use of the Website after any changes constitutes acceptance of the new Terms.</p>
                    
                    <h2>2. Use of the Website</h2>
                    <ul>
                        <li>You must be at least 18 years old or have the legal capacity to enter into an agreement.</li>
                        <li>You agree to use the Website only for lawful purposes and in compliance with all applicable laws and regulations.</li>
                        <li>Unauthorized use of the Website, including but not limited to hacking, data scraping, or automated access, is strictly prohibited.</li>
                    </ul>
                    
                    <h2>3. User Accounts</h2>
                    <ul>
                        <li>You may be required to create an account to access certain features.</li>
                        <li>You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</li>
                        <li>We reserve the right to suspend or terminate accounts that violate these Terms.</li>
                    </ul>
                    
                    <h2>4. Intellectual Property</h2>
                    <p>All content on the Website, including text, graphics, logos, and software, is the property of the Company or its licensors and is protected by intellectual property laws. You may not reproduce, distribute, or modify any content without our prior written permission.</p>
                    
                    <h2>5. Privacy Policy</h2>
                    <p>Your use of the Website is also governed by our <a class="text-primary" type="button" (click)="navigate()">Privacy Policy</a>, which outlines how we collect, use, and protect your data.</p>
                    
                    <h2>6. Limitation of Liability</h2>
                    <ul>
                        <li>The Website is provided "as is" without any warranties, express or implied.</li>
                        <li>We are not responsible for any damages arising from your use of the Website, including but not limited to data loss, service interruptions, or security breaches.</li>
                        <li>In no event shall our liability exceed the amount paid by you, if any, for accessing the Website.</li>
                    </ul>
                    
                    <h2>7. Termination</h2>
                    <p>We reserve the right to terminate or suspend access to the Website at our sole discretion, without prior notice, for any reason, including violation of these Terms.</p>
                    
                    <h2>8. Governing Law</h2>
                    <p>These Terms shall be governed by and construed in accordance with the laws of Indian Jurisdiction, without regard to its conflict of law principles.</p>
                    
                    <h2>9. Contact Information</h2>
                    <p class="contact">If you have any questions about these Terms, please contact us at <a href="mailto:vsspl_affairs@msservicesinc.com">vsspl_affairs&#64;msservicesinc.com</a>.</p>

                    
                </section>

                    

            </div>
        </div>
    </div>
</section>
